
import React, { useState } from "react";
import assets from "../assets/assets";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, EffectFade } from "swiper/modules";

const TrustedSlider = () => {
  const { b_testimonial, testimonial01, testimonial02, testimonial03, invision, logitech,monday } = assets();
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handlePrevClick = () => {
    if (swiperInstance) {
      swiperInstance.slidePrev();
    }
  };

  const handleNextClick = () => {
    if (swiperInstance) {
      swiperInstance.slideNext();
    }
  };

  const testimonials = [
    {
      image: testimonial01,
      logo: invision,
      text: "Their team are easy to work with and helped me make amazing websites in a short amount of time. Thanks guys for all your hard work. Trust us we looked for a very long time.",
      name: "Herman Miller",
      company: "Monday",
    },
    {
      image: testimonial02,
      logo: logitech,
      text: "Their team are easy to work with and helped me make amazing websites in a short amount of time. Thanks guys for all your hard work. Trust us we looked for a very long time.",
      name: "Leonel Mooney",
      company: "Logitech",
    },
    {
      image: testimonial03,
      logo: monday,
      text: "Their team are easy to work with and helped me make amazing websites in a short amount of time. Thanks guys for all your hard work. Trust us we looked for a very long time.",
      name: "Matthew Taylor",
      company: "Invision",
    },
  ];

  return (
    <section className="pt-0">
      <div
        className="container background-no-repeat background-position-top"
        style={{ backgroundImage: `url(${b_testimonial})` }}
      >
        <div className="row justify-content-center mb-5 pb-3">
          <div className="col-xxl-6 col-lg-6 col-md-6 text-center">
            <h1 className="text-dark-gray fw-700 ls-minus-2px">
              Trusted by the world's fastest growing companies.
            </h1>
          </div>
        </div>

        <div className="row justify-content-center align-items-center position-relative mb-6 sm-mb-8">
          <div className="col-xl-10">
            <Swiper
              slidesPerView={1}
              spaceBetween={10}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              loop={true}
              speed={1000}
              breakpoints={{
                0: { slidesPerView: 1 }
              }}
              modules={[EffectFade, Autoplay]}
              className="mySwiper"
              onSwiper={setSwiperInstance}
            >
              {testimonials.map((review, index) => (
                <SwiperSlide key={index} className="rounded">
                  <div className="row align-items-center justify-content-center">
                    <div className="col-8 col-md-4 col-sm-6 text-center md-mb-30px">
                      <img className="w-full h-full" src={review.image} alt={review.name} />
                    </div>
                    <div className="col-lg-5 col-md-7 text-center text-md-start">
                      <a href="#" className="mb-15px d-block">
                        <img src={review.logo} className="h-35px" alt={review.company} />
                      </a>
                      <span className="mb-5px d-table fs-18 lh-30 fw-500 text-dark-gray">
                        {review.text}
                      </span>
                      <span className="fs-15 text-uppercase fw-800 text-dark-gray ls-05px">
                        {review.name}, {review.company}
                      </span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div onClick={handlePrevClick} className="swiper-button-previous-nav swiper-button-prev md-left-0px">
              <i className="feather icon-feather-arrow-left icon-extra-medium text-dark-gray"></i>
            </div>
            <div onClick={handleNextClick} className="swiper-button-next-nav swiper-button-next md-right-0px">
              <i className="feather icon-feather-arrow-right icon-extra-medium text-dark-gray"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedSlider;

